import {
  faPhone,
  faSearch,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchBarIsOpen, setSearchBarIsOpen] = useState(false);
  const [dropdownStates, setDropdownStates] = useState({
    company: false,
    investors: false
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1550);
  const [ModelIsOpen, setModelIsOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [phone, setPhone] = useState('');

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1550;
      setIsMobile(mobile);
      if (!mobile) {
        // Close all dropdowns when switching to desktop
        setDropdownStates({
          company: false,
          investors: false
        });
        setIsMenuOpen(false); // Close mobile menu on desktop
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Close all dropdowns when toggling menu
    setDropdownStates({
      company: false,
      investors: false
    });
  };

  const toggleSearchBar = () => {
    setSearchBarIsOpen(!searchBarIsOpen);
  };

  const toggleModel = () => {
    setModelIsOpen(!ModelIsOpen);
  };

  const toggleDropdown = (dropdownName) => {
    // Only toggle for mobile or when clicking directly on the link in desktop if not hovered
    if (isMobile) {
      setDropdownStates(prev => ({
        ...prev,
        [dropdownName]: !prev[dropdownName]
      }));
    }
  };

  const handleDesktopHover = (dropdownName, isHovering) => {
    if (!isMobile) {
      setDropdownStates(prev => ({
        ...prev,
        [dropdownName]: isHovering
      }));
    }
  };

  const formRef = useRef();

  const handleModalSubmit = async (e) => {
    e.preventDefault();

    // Make sure phone starts with +
    let formattedPhone = phone.startsWith("+") ? phone : `+${phone}`;

    // General E.164 validation (8 to 15 digits with optional +)
    const intlPhoneRegex = /^\+?[1-9]\d{7,14}$/;

    // Strict India validation: +91 followed by exactly 10 digits (first digit 6–9)
    const indiaPhoneRegex = /^\+91[6-9]\d{9}$/;

    // India-specific check
    if (formattedPhone.startsWith("+91")) {
      if (!indiaPhoneRegex.test(formattedPhone)) {
        setShowError(true);
        setTimeout(() => setShowError(false), 4000);
        return;
      }
    } else {
      // International validation
      if (!intlPhoneRegex.test(formattedPhone)) {
        setShowError(true);
        setTimeout(() => setShowError(false), 4000);
        return;
      }
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/send-req-call`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: formattedPhone }), // ✅ send normalized
      });

      const result = await response.json();
      if (result.success) {
        setShowSuccess(true);
        setTimeout(() => {
          setModelIsOpen(false);
          setPhone("");
          setShowSuccess(false);
        }, 4000);
        formRef.current.reset();
      } else {
        console.error("❌ Error:", result.message);
      }
    } catch (error) {
      console.error("❌ Error:", error);
    }
  };

  const searchablePages = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Why Marvel', path: '/WhyMarvel' },
    { name: 'Presence', path: '/presence' },
    { name: 'Photos Gallery', path: '/photos-gallery' },
    { name: 'Videos Gallery', path: '/videos-gallery' },
    { name: 'Products', path: '/products' },
    { name: 'Find Dealer', path: '/find-dealer' },
    { name: 'Special Solutions', path: '/special-solutions' },
    { name: 'Inspiration', path: '/inspiration' },
    { name: 'Contact', path: '/contact' },
    { name: 'Career', path: '/career' },
    { name: 'Jobs', path: '/career/jobs' },
    { name: 'Operating Systems', path: '/operating-systems' },
    { name: 'Light Control Privacy', path: '/light-control-privacy' },
    { name: 'Innovation', path: '/innovation' },
    { name: 'Terms & Conditions', path: '/terms-conditions' },
    { name: 'Privacy Policy', path: '/privacy-policy' },
    { name: 'Shipping Policy', path: '/shipping-policy' },
    { name: 'Energy Efficiency', path: '/energy-efficiency' },
    { name: 'Fabric Shade', path: '/fabric-shade' },
    { name: 'Blogs', path: '/blogs' },
    { name: 'News', path: '/news' },
    { name: 'Frequently Asked Questions', path: '/frequently-asked-questions' },
    { name: 'Filter Inspiration', path: '/filter-inspiration' },
    { name: 'Child Safety', path: '/child-safety' },
    { name: 'Events', path: '/events' },
    { name: 'Exhibitions', path: '/exhibitions' },
    { name: 'Company Fact Sheet', path: '/company-fact-sheet' },
    { name: 'Management', path: '/management' },
    { name: 'Marvel Decor EGM', path: '/marvel-decor-egm' },
    { name: 'Policies', path: '/policies' },
    { name: 'Shareholding Pattern', path: '/shareholding-pattern' },
    { name: 'Investor Grievance', path: '/investor-grievance' },
    { name: 'Preferential Issue', path: '/preferential-issue' },
    { name: 'Updates', path: '/updates' },
    { name: 'Financial Results', path: '/financial-results' },
    { name: 'Subsidiary Company', path: '/subsidiary-company' },
    { name: 'Statement of Deviation or Variation', path: '/statement-of-deviation-or-variation' },
    { name: 'Annual Report AGM', path: '/annual-report-agm' },

    { name: 'AR/AGM 2017-18', path: '/annual-report/ar-agm-2017-18' },
    { name: 'AR/AGM 2018-19', path: '/annual-report/ar-agm-2018-19' },
    { name: 'AR/AGM 2019-20', path: '/annual-report/ar-agm-2019-20' },
    { name: 'AR/AGM 2020-21', path: '/annual-report/ar-agm-2020-21' },
    { name: 'AR/AGM 2021-22', path: '/annual-report/ar-agm-2021-22' },
    { name: 'AR/AGM 2022-23', path: '/annual-report/ar-agm-2022-23' },
    { name: 'AR/AGM 2023-24', path: '/annual-report/ar-agm-2023-24' },
    { name: 'AR/AGM 2024-25', path: '/annual-report/ar-agm-2023-24' },

    { name: 'Incorporation of Subsidiary – Callistus Window Fashion USA', path: '/subsidiary-company/uk-ltd' },
    { name: 'Audit Report – Callistus Blinds Middle East', path: '/subsidiary-company/middle-east' },
    { name: 'Incorporation of Subsidiary – Callistus Window Fashion USA', path: '/subsidiary-company/uk-ltd' },

    { name: 'Investors Presentation June 2025', path: '/updates/investors-presentation' },
    { name: 'Investors Presentation November 2024', path: '/updates/investors-presentation-new' },
    { name: 'Statement of Deviation(s) or Variation(s)', path: '/updates/statement-of-deviations-or-variations' },

    { name: 'Printed Blinds', path: '/printed-blinds' },
    { name: 'Automation', path: '/automation' },
    { name: 'roller blinds', path: '/products/roller-blinds' },
    { name: 'roman blinds', path: '/products/roman-blinds' },
    { name: 'luzon blinds', path: '/products/luzon-blinds' },
    { name: 'wooden - venetian blinds', path: '/products/wooden-venetian-blinds' },
    { name: 'printed blinds', path: '/printed-blinds' },
    { name: 'skylight blinds', path: '/products/skylight-blinds' },
    { name: 'colby blinds', path: '/products/colby-blinds' },
    { name: 'automation', path: '/automation' },
    { name: 'sierra blinds', path: '/products/sierra-blinds' },
    { name: 'panel blinds', path: '/products/panel-blinds' },
    { name: 'grayson blinds', path: '/products/grayson-blinds' },
    { name: 'meliso blinds', path: '/products/meliso-blinds' },
    { name: 'eton blinds', path: '/products/eton-blinds' },
    { name: 'patricia blinds', path: '/products/patricia-blinds' },
    { name: 'aric blinds', path: '/products/aric-blinds' },
    { name: 'dorren blinds', path: '/products/dorren-blinds' },
    { name: 'vertical blinds', path: '/products/vertical-blinds' },

    { name: 'Colby Fabric', path: '/products/colby-blinds/colby-fabric' },
    { name: 'Grayson Fabric', path: '/products/grayson-blinds/grayson-fabric' },
    { name: 'Roller Fabric', path: '/products/roller-blinds/roller-fabric' },
    { name: 'Wooden Slates', path: '/products/wooden-venetian-blinds/wooden-slates' },
    { name: 'LuzonFabric', path: '/products/luzon-blinds/luzon-fabric' },
    { name: 'Skylight Fabric', path: '/products/skylight-blinds/skylight-fabric' },
    { name: 'Panel Fabric', path: '/products/panel-blinds/panel-fabric' },
    { name: 'Roman Fabric', path: '/products/roman-blinds/roman-fabric' },
    { name: 'Vertical Fabric', path: '/products/vertical-blinds/vertical-fabric' },

    { name: 'Marvel at New Parliament House', path: '/blog/marvel-at-new-parliament-house' },

    { name: 'We have arrived United Kingdom', path: '/news/we_have_arrived_uk/' },
    { name: 'Callistus Blinds goes International', path: '/news/callistus-blinds-goes-international/' },

    { name: "BDM - Project & Retail Sales (Mumbai)", path: '/job/bdm-project-retail-sales-mumbai' },
    { name: "BDE - Sales & Marketing (Mumbai)", path: '/job/bde-sales-marketing-mumbai' },
    { name: "BDM - Retail Sales (Dealer + Distributor) (Ahmedabad)", path: '/job/bdm-retail-sales-dealer-distributor-ahmedabad' },
    { name: "BDM - Project Sales (Ahmedabad)", path: '/job/bdm-project-sales-ahmedabad' },
    { name: "BDM - Retail Sales (Dealer + Distributor) (Delhi)", path: '/job/bdm-retail-sales-dealer-distributor-delhi' },
    { name: "BDM - Project Sales (Delhi)", path: '/job/bdm-project-sales-delhi' },
    { name: "BDM - Project & Retail Sales (Kolkata)", path: '/job/bdm-project-retail-sales-kolkata' },
    { name: "BDM - Project & Retail Sales (Pune)", path: '/job/bdm-project-retail-sales-pune' },
    { name: "BDM - Rest of the World (Mumbai)", path: '/job/bdm-rest-of-the-world-mumbai' },
    { name: "Project Execution Manager - Operations + Design (Mumbai)", path: '/job/project-execution-manager-operations-design-mumbai' },
    { name: "Project Coordinator - Operations + Design (Mumbai)", path: '/job/project-coordinator-operations-design-mumbai' },
    { name: "Operation Manager (Service head) - Pan India - Operations (Mumbai)", path: '/job/operation-manager-service-head-pan-india-operations-mumbai' },
    { name: "Purchase Manager - Purchase (Jamnagar)", path: '/job/purchase-manager-purchase-jamnagar' },
    { name: "Operation Manager - Operations (Jamnagar)", path: '/job/operation-manager-operations-jamnagar' },
    { name: "Finance Head - Finance and Accounting (Jamnagar)", path: '/job/finance-head-finance-and-accounting-jamnagar' },
    { name: "Interior Designer - Designer (Jamnagar)", path: '/job/interior-designer-designer-jamnagar' },
    { name: "Executive Assistant (Mumbai)", path: '/job/executive-assistant-mumbai' },

    { name: 'Colby Top-Down Bottom-Up', path: '/top-down-bottom-up' },
    { name: 'Colby Blinds Day and Night', path: '/colby-blinds-day-and-night' },
    { name: 'Colby Blinds Remote Control', path: '/colby-blinds-remote-control' },
    { name: 'Sierra Blinds Manual', path: '/sierra-blinds-manual' },
    { name: 'Grayson Blinds Manual', path: '/grayson-blinds-manual' },
    { name: 'Grayson Blinds Remote Control', path: '/grayson-blinds-remote-control' },
    { name: 'Roller Blinds Manual', path: '/roller-blinds-manual' },
    { name: 'Roller Remote Control', path: '/roller-remote-control' },
    { name: 'Roller Blinds One Touch Up', path: '/roller-blinds-one-touch-up' },
    { name: 'Wooden Venetian Blinds Manual', path: '/wooden-venetian-blinds-manual' },
    { name: 'Wooden Venetian Blinds Remote Control', path: '/wooden-venetian-blinds-remote-control' },
    { name: 'Wooden Venetian Blinds Smart Phone Control', path: '/wooden-venetian-blinds-smart-phone-control' },
    { name: 'Luzon Blinds Manual', path: '/luzon-blinds-manual' },
    { name: 'Luzon Blinds Remote Control', path: '/luzon-blinds-remote-control' },
    { name: 'Skylight Blinds Remote Control', path: '/skylight-blinds-remote-control' },
    { name: 'Panel Blinds Remote Control', path: '/panel-blinds-remote-control' },
    { name: 'Panel Blinds Cord Control', path: '/panel-blinds-cord-control' },
    { name: 'Roman Blinds Manual', path: '/roman-blinds-manual' },
    { name: 'Roman Blinds Remote Control', path: '/roman-blinds-remote-control' },
    { name: 'Aric Blinds Manual', path: '/aric-blinds-manual' },
    { name: 'Patricia Blinds Manual', path: '/patricia-blinds-manual' },
    { name: 'Patricia Blinds Remote Control', path: '/patricia-blinds-remote-control' },
    { name: 'Dorren Blinds Manual', path: '/dorren-blinds-manual' },
    { name: 'Meliso Blinds Remote Control', path: '/meliso-blinds-remote-control' },
    { name: 'Eton Blinds Manual', path: '/eton-blinds-manual' },

    { name: 'Luzon Blinds', path: '/videos/luzon-blinds' },
    { name: 'Colby Blinds by Marvel Window Fashion', path: '/videos/colby-blinds-by-Marvel-window-fashion' },
    { name: 'Marvel Panel Blinds', path: '/videos/marvel-panel-blinds' },
    { name: 'Grayson Blinds', path: '/videos/new-window-nice' },
    { name: 'Wooden Venetian Blinds', path: '/videos/wooden-venetian' },
    { name: 'Wooden Venetian Manual', path: '/videos/wooden-venetian-manual' },
    { name: 'Roller Blinds One Touch Up', path: '/videos/roller-blinds-one-touch-up' },
    { name: 'Colby Blinds Top Down Bottom Up (TDBU)', path: '/videos/colby-blinds-top-down-bottom-up-tdbu' },
    { name: 'Patricia Blind Automation', path: '/videos/patricia-blind-automation' },

    { name: 'Biz Bash Event (Goa)', path: '/events/biz-bash-event-goa/' },
    { name: 'Achievers Mega Event (Mumbai)', path: '/events/achievers-mega-event-mumbai/' },
    { name: 'Achievers Mega Event (Goa)', path: '/events/achievers-mega-event-goa/' },
    { name: 'Achievers Mega Event (Lonavala)', path: '/events/achievers-mega-event-lonavala/' },

    { name: 'HGH India (Mumbai)', path: '/Exhibitions/hgh-exhibition' },
    { name: 'ACE Tech (Delhi, Mumbai, Kolkata, Surat, Bangalore, Hyderabad)', path: '/Exhibitions/ace-tech' },
    { name: 'Index (Mumbai)', path: '/Exhibitions/index-mumbai' },

  ];


  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (query.length > 0) {
      const filteredResults = searchablePages.filter((page) =>
        page.name.toLowerCase().includes(query.toLowerCase())
      );
      setSearchResults(filteredResults);
    } else {
      setSearchResults([]);
    }
  };


  return (
    <>
      <div className="navbar-container">
        <header className="navbar">
          <div className="nav-col1">
            <div className="nav-logo">
              <Link to="/">
                <img
                  src="/Logo/marvel-logo.png"
                  alt="Marvel Logo"
                  className="navbar-logo"
                />
              </Link>
            </div>
            <div className="mobile-sec2">
              <div className="mobile-searchbar">
                <div className="nav-search-bar" onClick={toggleSearchBar}>
                  <FontAwesomeIcon icon={faSearch} />
                </div>
              </div>
              <div
                className={`navbar-toggle ${isMenuOpen ? 'open-toggle' : ''}`}
                onClick={toggleMenu}
              >
                <span className="toggle-L1"></span>
                <span className="toggle-L2"></span>
                <span className="toggle-L3"></span>
              </div>
            </div>
          </div>

          <div className="nav-col2">
            <ul className={`nav-links ${isMenuOpen ? 'open-nav-links' : ''}`}>
              <li
                className={`company-link ${isMobile ? 'mobile' : 'desktop'} ${dropdownStates.company ? 'open' : ''}`}
                onClick={() => toggleDropdown('company')}
                onMouseEnter={() => handleDesktopHover('company', true)}
                onMouseLeave={() => handleDesktopHover('company', false)}
              >
                <Link to="#">
                  Company
                </Link>
                <ul className={`dropdown ${dropdownStates.company ? 'open' : ''}`}>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/WhyMarvel">Why Marvel</Link>
                  </li>
                  <li>
                    <Link to="/presence">Presence</Link>
                  </li>
                  <li>
                    <Link to="/photos-gallery">Gallery</Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/products">Products</Link>
              </li>

              {/* <li>
                <a href="https://www.marvelcallistus.com" target="_blank" rel="noopener noreferrer">
                  Projects
                </a>
              </li> */}

              <li>
                <Link to="/special-solutions">Special Solutions</Link>
              </li>

              <li>
                <Link to="/inspiration">Inspiration</Link>
              </li>

              <li
                className={`investors-link  ${isMobile ? 'mobile' : 'desktop'} ${dropdownStates.investors ? 'open' : ''}`}
                onClick={() => toggleDropdown('investors')}
                onMouseEnter={() => handleDesktopHover('investors', true)}
                onMouseLeave={() => handleDesktopHover('investors', false)}
              >
                <Link to="#">
                  Investors
                </Link>
                <ul className={`dropdown ${dropdownStates.investors ? 'open' : ''}`}>
                  <li>
                    <Link to="/company-fact-sheet">Company Fact Sheet</Link>
                  </li>
                  <li>
                    <Link to="/management">Management</Link>
                  </li>
                  <li>
                    <Link to="/policies">Policies</Link>
                  </li>
                  <li>
                    <Link to="/shareholding-pattern">Shareholding Pattern</Link>
                  </li>
                  <li>
                    <Link target='__blank' to="/Documnets/Composition-of-various-committees-of-Board-of-Directors.pdf">Composition of BOD Committees</Link>
                  </li>
                  <li>
                    <Link to="/investor-grievance">Investor Grievance</Link>
                  </li>
                  <li>
                    <Link to="/financial-results">Financial Results & Annual Report</Link>
                  </li>
                  <li>
                    <Link to="/updates">Updates</Link>
                  </li>
                  <li>
                    <Link to="/subsidiary-company">Subsidiary Company</Link>
                  </li>
                  <li>
                    <Link to="/marvel-decor-egm">EGM</Link>
                  </li>
                  <li>
                    <Link target='__blank' to="/Documnets/Prospectus_Marvel_Decor_Limited.pdf">Prospectus</Link>
                  </li>
                  <li>
                    <Link to="/preferential-issue">Preferential issue</Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/exhibitions">Exhibitions</Link>
              </li>

              <li>
                <Link to="/events">Events</Link>
              </li>

              <li>
                <Link to="/career">Career</Link>
              </li>

              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          <div className="nav-col3" onClick={toggleSearchBar}>
            <div className="nav-search-bar">
              <FontAwesomeIcon icon={faSearch} />
            </div>
          </div>

          <div className="nav-col4">
            <div className="nav-call-btn" onClick={toggleModel}>
              REQUEST A CALL BACK
              <FontAwesomeIcon icon={faPhone} style={{ marginLeft: '8px' }} />
            </div>
          </div>
        </header>
      </div>

      <div className={`search-container ${searchBarIsOpen ? 'Open-search-container' : ''}`}>
        <input
          type="text"
          className="search-input"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
        />
        <div className="search-results" style={searchQuery ? { marginTop: "10px" } : {}}>
          {searchQuery && searchResults.length === 0 && (
            <div className="no-results">No results found</div>
          )}
          {searchResults.map((result, index) => (
            <Link
              key={index}
              to={result.path}
              className="search-result-item"
              onClick={() => {
                setSearchBarIsOpen(false);
                setSearchQuery('');
                setSearchResults([]);
              }}
            >
              {result.name}
            </Link>
          ))}
        </div>
      </div>

      <div className={`modal-overlay ${ModelIsOpen ? 'opener' : ''}`}>
        <div className="callback-modal">
          <button className="modal-close-btn" onClick={toggleModel}>
            <FontAwesomeIcon icon={faTimes} />
          </button>

          <div className="modal-title">
            <h5>Request a Call back</h5>
          </div>
          <div className="Model-Bottom">
            <form ref={formRef} onSubmit={handleModalSubmit}>
              <div className="modal-input">
                <PhoneInput
                  country={'in'}
                  enableSearch={true}
                  value={phone}
                  onChange={(phone) => setPhone(phone)}
                  placeholder="Your Number"
                  inputClass="modal-phone-input" // Add a class for styling
                  containerClass="modal-phone-input-container" // Add a class for styling
                />
              </div>
              {showSuccess && (
                <div className="success-message" style={{ marginTop: '8px' }}>
                  <p>Thank you! We'll call you back shortly.</p>
                </div>
              )}
              {showError && (
                <div className="denger-message" style={{ marginTop: '8px' }}>
                  <p>Please enter a valid phone number.</p>
                </div>
              )}
              <div className="modal-buttons">
                <button type='submit' className="model-submit-btn">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;